import { render, staticRenderFns } from "./Staging-Delivered-Correction-View.vue?vue&type=template&id=284d9860&scoped=true&"
import script from "./Staging-Delivered-Correction-View.vue?vue&type=script&lang=js&"
export * from "./Staging-Delivered-Correction-View.vue?vue&type=script&lang=js&"
import style0 from "./Staging-Delivered-Correction-View.vue?vue&type=style&index=0&id=284d9860&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284d9860",
  null
  
)

export default component.exports